<template>
  <div class="flex items-center h-full">
    <span
      v-if="daysUntilDue !== null"
      class="px-2 py-0.5 rounded text-xs font-medium"
      :class="badgeClass"
    >
      {{ daysLabel }}
    </span>
    <span v-else class="text-xs text-gray-400">-</span>
  </div>
</template>

<script>
export default {
  name: 'Quality_DueDateCell',
  props: ['params'],
  computed: {
    daysUntilDue() {
      return this.params.data?.days_until_due;
    },
    isOverdue() {
      return this.daysUntilDue !== null && this.daysUntilDue < 0;
    },
    isUrgent() {
      return this.daysUntilDue !== null && this.daysUntilDue >= 0 && this.daysUntilDue <= 7;
    },
    isSoon() {
      return this.daysUntilDue !== null && this.daysUntilDue > 7 && this.daysUntilDue <= 30;
    },
    badgeClass() {
      if (this.isOverdue) return 'bg-red-100 text-red-700';
      if (this.isUrgent) return 'bg-orange-100 text-orange-700';
      if (this.isSoon) return 'bg-yellow-100 text-yellow-700';
      return 'bg-gray-100 text-gray-600';
    },
    daysLabel() {
      if (this.daysUntilDue === null) return '';
      if (this.daysUntilDue < 0) {
        return `${Math.abs(this.daysUntilDue)}d overdue`;
      }
      if (this.daysUntilDue === 0) return 'Due today';
      return `${this.daysUntilDue}d left`;
    }
  }
};
</script>
